import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Modal} from '@softline/ui-core';

@Component({
  selector: 'lib-image-carousel-dialog',
  imports: [],
  templateUrl: './image-carousel-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./image-carousel-dialog.component.css'] })
export class ImageCarouselDialogComponent implements Modal<any> {
  images: File[] = [];
  selectedIndex?: number;

  get hasNext(): boolean {
    return !!this.selectedIndex && this.images.length - 1 < this.selectedIndex;
  }

  get hasPrevious(): boolean {
    return !!this.selectedIndex && this.selectedIndex > 0;
  }

  get selectedImageURL(): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      URL.createObjectURL(this.images[this.selectedIndex ?? 0])
    );
  }

  close!: (result: any) => void;

  constructor(private sanitizer: DomSanitizer) {}

  registerCloseHandler(handler: (result: any) => void) {
    this.close = handler;
  }

  showNext(): void {}

  showPrevious(): void {}
}
